var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10040",
    "data-name": "Group 10040",
    transform: "translate(-1224 -2887)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2865",
    "data-name": "Rectangle 2865",
    width: 30,
    height: 30,
    transform: "translate(1224 2887)",
    fill: "#5a2626",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M11.515,9.849,3.181,1.515,1.515,3.181l8.334,8.334L1.515,19.849l1.666,1.666,8.334-8.334,8.334,8.334,1.666-1.666-8.334-8.334,8.334-8.334L19.849,1.515Z",
    transform: "translate(1227.485 2890.485)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ac327205302dac6a0d84dce3556cd7f2.svg";
export { ForwardRef as ReactComponent };